export type MintedGuardianSendResult =
  | { ok: false; presentedAsSuccess: false; stage: 'intent'; error: string }
  | { ok: boolean; presentedAsSuccess: boolean; stage: 'send'; intentId: string; status: number; data: Record<string, any> };

export async function mintedGuardianSend(input: {
  fetchImpl?: typeof fetch;
  clientId: string;
  documentId: string;
  recipientEmail?: string;
  recipientName?: string;
  dispatchType?: string;
  sendUrl: string;
  sendBody: (intentId: string) => Record<string, unknown>;
}): Promise<MintedGuardianSendResult> {
  const fetchImpl = input.fetchImpl || fetch;
  const intentRes = await fetchImpl('/api/communications/esign/intent', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      clientId: input.clientId,
      documentId: input.documentId,
      recipientEmail: input.recipientEmail,
      recipientName: input.recipientName,
      dispatchType: input.dispatchType || 'CLINICAL_DOC'
    })
  });
  const intentData = await intentRes.json().catch(() => ({} as Record<string, any>));
  if (!intentRes.ok || !intentData.intentId) {
    return {
      ok: false,
      presentedAsSuccess: false,
      stage: 'intent',
      error: intentData.error || 'Failed to acquire eSign dispatch authorization.'
    };
  }

  const sendRes = await fetchImpl(input.sendUrl, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Initiation-Source': 'MANUAL_UI'
    },
    body: JSON.stringify(input.sendBody(String(intentData.intentId)))
  });
  const data = await sendRes.json().catch(() => ({} as Record<string, any>));
  const sendSucceeded = sendRes.ok && data.success === true;
  return {
    ok: sendRes.ok,
    presentedAsSuccess: sendSucceeded,
    stage: 'send',
    intentId: String(intentData.intentId),
    status: sendRes.status,
    data
  };
}
